// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Animation{margin-bottom:20px;max-width:360px;max-height:330px;margin:0 auto}.Animation>div{outline:none;cursor:pointer}.Animation svg{display:block}\n", ""]);
// Exports
module.exports = exports;
